var Flickity = require("flickity")

const featureCarousel = document.querySelector(".gear-detail-additional-features .feature-carousel")
const is_mobile = $(window).width() >= 1024 ? false : true

if (featureCarousel && is_mobile) {
  softgoodColors = new Flickity(".gear-detail-additional-features .feature-carousel", {
    cellSelector: ".gear-detail-additional-features .feature-carousel .tab-pane",
    contain: true,
    cellAlign: "center",
    autoPlay: true,
    pauseAutoPlayOnHover: true,
    prevNextButtons: false,
    pageDots: ">1",
    adaptiveHeight: false,
    resize: true,
    lazyLoad: true,
    wrapAround: true,
  })
}
